<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="400px"
    top="40vh"
    custom-class="forbid-dialog">
    <div style="padding: 0 10px;">
      <div>
        <i class='el-icon-warning' style='color:#FAB007; font-size: 17px;margin-right: 10px'></i>
        <span style='font-size: 16px; font-weight: bold; color: #1F2733;'>禁用</span>
      </div>
      <div style='font-size: 14px; color: #1F2733; padding: 10px 25px;'>
        禁用【{{`${info.goodsName}_${info.sn}`}}】后请选择已上架商品是否进行下架：
      </div>
      <el-radio-group v-model="forbid" style="padding: 0 25px;">
        <el-radio :label="0">暂不下架</el-radio>
        <el-radio :label="1">全部下架</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      dialogVisible: false,
      forbid: 0,
    };
  },
  watch: {
    dialogVisible (v) {
      if (v) this.forbid = 0;
    },
  },
  methods: {
    handleSure () {
      this.$emit('change', this.forbid);
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">
.el-dialog__wrapper .forbid-dialog {
  border-radius: 6px;
  .el-dialog__header {
    border-bottom: 0;
  }
}
</style>
